(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["todas-bento-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const MOBILE_MAX = 749;
    function isMobile() { return window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches; }
    function getDrawer(trigger) {
      const id = trigger.dataset.drawerTarget;
      return id ? document.getElementById(id) : null;
    }
    function getModal(trigger) {
      const id = trigger.dataset.modalTarget;
      return id ? document.getElementById(id) : null;
    }
    function closeAllDrawers(except) {
      document.querySelectorAll('[data-bento-drawer]').forEach((d) => {
        if (d !== except) {
          d.setAttribute('aria-hidden', 'true');
          const triggerForD = document.querySelector(`[data-drawer-target="${d.id}"]`);
          if (triggerForD) triggerForD.setAttribute('aria-expanded', 'false');
        }
      });
    }
    function openDrawer(trigger, drawer) {
      closeAllDrawers(drawer);
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer(trigger, drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
    }
    function openModal(trigger, modal) {
      if (typeof modal.showModal === 'function') {
        modal.showModal();
        trigger.setAttribute('aria-expanded', 'true');
      }
    }
    function closeModal(trigger, modal) {
      if (typeof modal.close === 'function') {
        modal.close();
        trigger.setAttribute('aria-expanded', 'false');
      }
    }
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-bento-trigger]');
      if (trigger) {
        e.preventDefault();
        const drawer = getDrawer(trigger);
        const modal = getModal(trigger);
        if (isMobile() && modal) {
          if (modal.open) { closeModal(trigger, modal); } else { openModal(trigger, modal); }
          return;
        }
        if (drawer) {
          const expanded = trigger.getAttribute('aria-expanded') === 'true';
          if (expanded) { closeDrawer(trigger, drawer); } else { openDrawer(trigger, drawer); }
        }
        return;
      }
      const closeBtn = e.target.closest('[data-bento-modal-close]');
      if (closeBtn) {
        const modal = closeBtn.closest('[data-bento-modal]');
        if (modal) {
          const triggerForModal = document.querySelector(`[data-modal-target="${modal.id}"]`);
          if (triggerForModal) closeModal(triggerForModal, modal);
        }
        return;
      }
      const drawerCloseBtn = e.target.closest('[data-bento-drawer-close]');
      if (drawerCloseBtn) {
        const drawer = drawerCloseBtn.closest('[data-bento-drawer]');
        if (drawer) {
          const triggerForDrawer = document.querySelector(`[data-drawer-target="${drawer.id}"]`);
          if (triggerForDrawer) closeDrawer(triggerForDrawer, drawer);
        }
        return;
      }
      const openDrawerEl = document.querySelector('[data-bento-drawer][aria-hidden="false"]');
      if (openDrawerEl && !e.target.closest('[data-bento-item]')) {
        const triggerFor = document.querySelector(`[data-drawer-target="${openDrawerEl.id}"]`);
        if (triggerFor) closeDrawer(triggerFor, openDrawerEl);
      }
    });
    document.querySelectorAll('[data-bento-modal]').forEach((modal) => {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) {
          const triggerForModal = document.querySelector(`[data-modal-target="${modal.id}"]`);
          if (triggerForModal) closeModal(triggerForModal, modal);
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const openDrawerEl = document.querySelector('[data-bento-drawer][aria-hidden="false"]');
        if (openDrawerEl) {
          const triggerFor = document.querySelector(`[data-drawer-target="${openDrawerEl.id}"]`);
          if (triggerFor) closeDrawer(triggerFor, openDrawerEl);
        }
      }
    });
    let wasMobile = isMobile();
    window.addEventListener('resize', function () {
      const nowMobile = isMobile();
      if (nowMobile !== wasMobile) {
        wasMobile = nowMobile;
        document.querySelectorAll('[data-bento-drawer]').forEach((d) => { d.setAttribute('aria-hidden', 'true'); });
        document.querySelectorAll('[data-bento-modal]').forEach((m) => { if (m.open) m.close(); });
        document.querySelectorAll('[data-bento-trigger]').forEach((t) => { t.setAttribute('aria-expanded', 'false'); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["todas-info-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.todasDrawerBound) return;
    window.todasDrawerBound = true;

    function open(root) {
      var panel = root.querySelector('.todas-drawer__panel');
      var backdrop = root.querySelector('.todas-drawer__backdrop');
      var trigger = root.querySelector('[data-drawer-open]');
      if (!panel) return;
      panel.hidden = false;
      if (backdrop) backdrop.hidden = false;
      requestAnimationFrame(function () { root.setAttribute('data-open', ''); });
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      panel.focus();
    }
    function close(root) {
      var panel = root.querySelector('.todas-drawer__panel');
      var backdrop = root.querySelector('.todas-drawer__backdrop');
      var trigger = root.querySelector('[data-drawer-open]');
      root.removeAttribute('data-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      setTimeout(function () { if (panel) panel.hidden = true; if (backdrop) backdrop.hidden = true; }, 280);
      if (trigger) trigger.focus();
    }

    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-drawer-open]');
      if (o) { var r = o.closest('.todas-drawer'); if (r) open(r); return; }
      var c = e.target.closest('[data-drawer-close]');
      if (c) { var r2 = c.closest('.todas-drawer'); if (r2) close(r2); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var openRoot = document.querySelector('.todas-drawer[data-open]');
        if (openRoot) close(openRoot);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["todas-related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Skydd: om en hover-bild (bild 2) är trasig/404, ta bort den så att
    // primärbilden inte blankar ut på hover. Delegerad i capture-fas.
    if (!window.todasCardImgGuard) {
      window.todasCardImgGuard = true;
      document.addEventListener('error', function (e) {
        var img = e.target;
        if (img && img.classList && img.classList.contains('todas-card__image--secondary')) {
          var card = img.closest('.todas-card');
          if (card) card.classList.remove('todas-card--has-secondary');
          img.remove();
        }
      }, true);
    }

    function initSlider(root) {
      var scroll = root.querySelector('[data-rel-scroll]');
      if (!scroll || root.dataset.relInit) return;
      root.dataset.relInit = '1';
      var prevBtn = root.querySelector('[data-rel-prev]');
      var nextBtn = root.querySelector('[data-rel-next]');

      function getScrollAmount() {
        var item = scroll.querySelector('.todas-rel__item');
        if (!item) return scroll.clientWidth * 0.8;
        var list = scroll.querySelector('.todas-rel__list');
        var gap = parseFloat(getComputedStyle(list).gap) || 16;
        return (item.offsetWidth + gap) * 2;
      }
      function updateArrows() {
        var max = scroll.scrollWidth - scroll.clientWidth - 2;
        if (prevBtn) prevBtn.disabled = scroll.scrollLeft <= 0;
        if (nextBtn) nextBtn.disabled = scroll.scrollLeft >= max;
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { scroll.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scroll.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }); });
      scroll.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }
    function initAll(root) {
      (root || document).querySelectorAll('[data-todas-rel]').forEach(initSlider);
    }
    initAll(document);
    // Re-init när rekommendationerna byts in async
    document.querySelectorAll('product-recommendations.todas-rel-host').forEach(function (host) {
      new MutationObserver(function () { initAll(host); }).observe(host, { childList: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["todas-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(section) {
      const scroll = section.querySelector('[data-slider-scroll]');
      const arrowsWrap = section.querySelector('[data-slider-arrows]');
      const prevBtn = section.querySelector('[data-slider-prev]');
      const nextBtn = section.querySelector('[data-slider-next]');
      const filters = section.querySelectorAll('[data-filter]');

      if (!scroll) return;

      filters.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const key = btn.getAttribute('data-filter');
          filters.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');

          const items = scroll.querySelectorAll('.todas-product-slider__item');
          items.forEach(function (item) {
            if (key === '__all__') {
              item.classList.remove('is-hidden');
              return;
            }
            const itemType = item.getAttribute('data-type') || '';
            const itemTags = (item.getAttribute('data-tags') || '').split(',');
            if (itemType === key || itemTags.indexOf(key) !== -1) {
              item.classList.remove('is-hidden');
            } else {
              item.classList.add('is-hidden');
            }
          });
          scroll.scrollTo({ left: 0, behavior: 'smooth' });
          updateArrows();
        });
      });

      function getScrollAmount() {
        const item = scroll.querySelector('.todas-product-slider__item:not(.is-hidden)');
        if (!item) return scroll.clientWidth * 0.8;
        const gap = parseFloat(getComputedStyle(scroll.querySelector('.todas-product-slider__list')).gap) || 16;
        return (item.offsetWidth + gap) * 2;
      }

      function updateArrows() {
        if (!arrowsWrap) return;
        const max = scroll.scrollWidth - scroll.clientWidth - 2;
        if (prevBtn) prevBtn.disabled = scroll.scrollLeft <= 0;
        if (nextBtn) nextBtn.disabled = scroll.scrollLeft >= max;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scroll.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scroll.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }

      scroll.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    document.querySelectorAll('[data-todas-slider]').forEach(initSlider);
  })();

  } catch(e) { console.error(e); }
})();
})();
